import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Communicators } from 'presentation/components/lib/communicators';
import Message from 'presentation/components/Message';
import MessageStack from 'presentation/components/MessageStack';
import replaceUserName from 'lib/replaceUserName';
import overrideStyle from 'lib/overrideStyle';

export default function InteractiveOnboarding(props) {
  const [shouldDisplayThirdAgentMessage, displayConfirmation] = useState(
    !!(props.isClientReady && props.email && props.name)
  );
  const [shouldDisplaySecondMessage, displaySecondMessage] = useState(!!props.userMessageContents.secondMessage);

  const onShouldDisplayConfirmation = () => {
    displayConfirmation(true);
    props.updateScrollPosition();
  };

  const onShouldDisplaySecondMessage = () => {
    displaySecondMessage(true);
    props.updateScrollPosition();
  };

  // if entering the email, wait 1 second before the confirmation appears
  useEffect(() => {
    const timeout =
      props.isReadyForConfirmation &&
      !shouldDisplayThirdAgentMessage &&
      setTimeout(() => onShouldDisplayConfirmation(), 1000);
    return () => clearTimeout(timeout);
  });
  // if entering the name, wait 1 second before the confirmation appears
  useEffect(() => {
    const secondMessageTimeout =
      props.userMessageContents.firstMessage &&
      !shouldDisplaySecondMessage &&
      setTimeout(() => onShouldDisplaySecondMessage(), 1000);
    return () => clearTimeout(secondMessageTimeout);
  });

  const firstAgentMessage = [
    <Message
      content={props.customText.interactiveOnboarding.emailPrompt || props.customText.onboardingMessage}
      sender={Communicators.AGENT}
      key="onboardingMessage"
    />,
  ];
  const firstCustomerMessage = [
    <Message content={props.userMessageContents.firstMessage} sender={Communicators.CUSTOMER} key="email" />,
  ];
  const secondAgentMessage = [
    <Message
      content={props.customText.interactiveOnboarding.namePrompt || props.customText.onboardingNameMessage}
      sender={Communicators.AGENT}
      key="namePrompt"
    />,
  ];
  const secondCustomerMessage = [
    <Message content={props.userMessageContents.secondMessage} sender={Communicators.CUSTOMER} key="name" />,
  ];
  const thirdAgentMessage = [
    <Message
      content={replaceUserName(
        props.name,
        props.customText.interactiveOnboarding.onboardingSuccess || props.customText.authenticationAutoResponse
      )}
      sender={Communicators.AGENT}
      key={'success'}
    />,
  ];

  return (
    <Wrapper>
      <MessageStack messages={firstAgentMessage} sender={Communicators.AGENT} />
      {props.userMessageContents.firstMessage && (
        <MessageStack messages={firstCustomerMessage} sender={Communicators.CUSTOMER} />
      )}
      {shouldDisplaySecondMessage && <MessageStack messages={secondAgentMessage} sender={Communicators.AGENT} />}
      {!!props.userMessageContents.secondMessage && (
        <MessageStack messages={secondCustomerMessage} sender={Communicators.CUSTOMER} />
      )}
      {props.isClientReady && shouldDisplayThirdAgentMessage && (
        <MessageStack messages={thirdAgentMessage} sender={Communicators.AGENT} />
      )}
    </Wrapper>
  );
}

InteractiveOnboarding.propTypes = {
  customText: PropTypes.object.isRequired,
  email: PropTypes.string,
  isClientReady: PropTypes.bool,
  userMessageContents: PropTypes.object,
  name: PropTypes.string,
};

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.secondary};
`;
